import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconEnginePower: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="engine-power">
    <path
      fillRule="evenodd"
      d="M5.4 5.286A2.386 2.386 0 0 1 7.786 2.9h5.428A2.386 2.386 0 0 1 15.6 5.286c0 .726-.588 1.314-1.314 1.314H12.6v1.3h1.071a2.6 2.6 0 0 1 1.84.762l.327.328a2.6 2.6 0 0 1 .761 1.838v.312a6.938 6.938 0 0 0-1.2.359v-.67a1.4 1.4 0 0 0-.41-.99l-.328-.329a1.4 1.4 0 0 0-.99-.41H6.1v6.971c.338.13.65.33.91.59l.829.829a1.4 1.4 0 0 0 .99.41H11L11 18c0 .374.03.742.086 1.1H8.829a2.6 2.6 0 0 1-1.839-.762l-.828-.828a1.4 1.4 0 0 0-.99-.41h-.066a2.6 2.6 0 0 1-1.442-.437l-.106-.07A2.6 2.6 0 0 1 2.4 14.43V10.5A2.6 2.6 0 0 1 5 7.9h3.4V6.6H6.714A1.314 1.314 0 0 1 5.4 5.286ZM7.786 4.1C7.13 4.1 6.6 4.63 6.6 5.286c0 .063.051.114.114.114h7.572a.114.114 0 0 0 .114-.114c0-.655-.531-1.186-1.186-1.186H7.786ZM9.6 6.6h1.8v1.3H9.6V6.6ZM4.9 9.104A1.4 1.4 0 0 0 3.6 10.5v3.93c0 .468.234.905.624 1.165l.105.07c.173.115.368.19.57.22V9.104Z"
      clipRule="evenodd"
    />
    <path d="M18 11h-.1V9.715c0-.725.588-1.314 1.314-1.314a2.386 2.386 0 0 1 2.386 2.386v1.21a6.973 6.973 0 0 0-1.2-.574v-.636c0-.655-.53-1.186-1.186-1.186a.114.114 0 0 0-.114.114v1.372A7.058 7.058 0 0 0 18 11ZM8.5 14.4h3.495c-.227.378-.42.78-.573 1.2H8.5a.6.6 0 1 1 0-1.2ZM7.9 12a.6.6 0 0 1 .6-.6H13a.6.6 0 0 1 0 1.2H8.5a.6.6 0 0 1-.6-.6ZM15.985 17.691l1.5-2.5 1.03.618-.955 1.591h1.94a.6.6 0 0 1 .514.909l-1.5 2.5-1.029-.618.955-1.591H16.5a.6.6 0 0 1-.515-.909Z" />
    <path
      fillRule="evenodd"
      d="M18 23a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-1.2a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6Z"
      clipRule="evenodd"
    />
  </Icon>
);
